import { ADAuth, AD, msalConfig, loginRequest } from "./adV2";
import { ADAuthV1, ADV1, msalConfigV1, loginRequestV1 } from "./adV1";

export {
  ADV1,
  AD,
  msalConfigV1,
  msalConfig,
  loginRequestV1,
  loginRequest,
  ADAuthV1,
  ADAuth,
};
